import { darkBlack } from 'material-ui/styles/colors';
import { darken, fade } from 'material-ui/utils/colorManipulator';

const scale = 1.0;
const headerHeight = 46 * scale;
const rowHeight = 36 * scale;
const actionBarHeight = 64 * scale;
const filtersHeight = 36 * scale;

export const primary1Color = '#39579e';
export const accent1Color = '#ec7d23';

// export const getTheme = (highContrast: boolean) => ({
export const getTheme = () => ({
  palette: {
    primary1Color,
    accent1Color,
    // disabledColor: highContrast ? fade(darkBlack, 0.5) : fade(darkBlack, 0.3),
    // borderColor: highContrast ? fade(darkBlack, 0.3) : grey300,
    disabledColor: fade(darkBlack, 0.5),
    borderColor: fade(darkBlack, 0.3),
    shadowColor: '#000'
  },
  tableHeaderColumn: {
    sortedColor: primary1Color,
    fontSize: 13,
    height: headerHeight
  },
  tableRow: {
    fontSize: 13,
    height: rowHeight
  },
  tableCaption: {
    height: actionBarHeight
  },
  tableFilters: {
    height: filtersHeight,
    fontSize: 13
  },
  tableFooter: {
    fontSize: 13,
    height: actionBarHeight
  },
  timePicker: {
    headerColor: primary1Color
  },
  datePicker: {
    selectColor: primary1Color,
    headerColor: primary1Color
  },
  dateTimePicker: {
    header: {
      backgroundColor: primary1Color
    },
    icon: {
      color: primary1Color
    }
  },
  confirmButton: {
    backgroundColor: '#52bc40'
  },
  listItem: {
    rightIconColor: 'white'
  },
  grid: {
    buttonBar: {
      display: 'flex',
      paddingBottom: 16
    },
    theadCheckbox: {
      uncheckColor: 'white',
      checkColor: 'orange'
    },
    theadTr: {
      background: 'black',
      color: 'white'
    },
    theadThSpan: {
      color: 'white'
    },
    theadThSorted: {
      color: primary1Color
    },
    gridWrapper: {
      padding: '0'
    },
    grid: {
      width: '100%',
      overflow: 'hidden',
      marginBottom: 20
    }
  },
  breadcrumbs: {
    display: 'flex',
    flexBasis: '100%',
    fontSize: '1em',
    marginTop: -55,
    zIndex: 1000,
    position: 'fixed',
    width: 'auto',
    alignItems: 'center',
    height: 21,
    color: 'black'
  },
  editor: {
    color: accent1Color
  },
  snack: {
    color: primary1Color
  },
  sidebar: {
    item: {
      color: '#ffffff',
      wordWrap: 'break-word',
      fontSize: 14,
      fontWeight: '100'
    },
    activeItem: {
      color: '#ffffff',
      backgroundColor: darken(primary1Color, 0.2),
      wordWrap: 'break-word',
      fontWeight: '100',
      fontSize: 14
    },
    panel: {
      sidebarWidth: 250,
      logoHeight: 96,
      marginTop: 20,
      transitionTime: '.2s',
      backgroundColor: primary1Color
    }
  },
  borderRadius: 0,
  raisedButton: {
    fontWeight: 100,
    fontSize: 12
  },
  paper: {
    zDepthShadows: [
      [1, 1, 0.3, 1, 1, 0.1],
      [3, 10, 0.16, 3, 10, 0.23],
      [10, 30, 0.19, 6, 10, 0.23],
      [14, 45, 0.25, 10, 18, 0.22],
      [19, 60, 0.3, 15, 20, 0.22]
    ].map(
      d =>
        `0 ${d[0]}px ${d[1]}px ${fade('#000', d[2])},
       0 ${d[3]}px ${d[4]}px ${fade('#000', d[5])}`
    )
  }
});



// WEBPACK FOOTER //
// ./src/theme.ts